import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LearningService } from 'src/app/services/learning/learning.service';

@Component({
  selector: 'app-chapter-heading',
  templateUrl: './chapter-heading.component.html',
  styleUrls: ['./chapter-heading.component.css']
})
export class ChapterHeadingComponent implements OnInit {

  Submitted:boolean = false;
  BookTitleList=[];
  ChapterHeadingList=[];

  constructor(private learningservice:LearningService,private LookupService: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

  GetAllChapterHeading() {
    this.ChapterHeadingList=[];
    if(this.LearningModel.BookTitleID>0){
    this.spinnerService.show();
    this.learningservice.GetAllChapterHeading(this.LearningModel.BookTitleID).subscribe((data: any) => {
      this.ChapterHeadingList = data.ChapterHeadingList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);     
    });
  }
  };

    LearningModel = {  
      ChapterID:0,  
      BookTitleID: 0,
      DisplayOrder:'',
      ChapterHeading: '',
      IsActive: true,
  };

  Clear() {
    this.LearningModel.ChapterID = 0;
    this.LearningModel.BookTitleID = 0;
    this.LearningModel.ChapterHeading = '';
    this.LearningModel.DisplayOrder='';
    this.LearningModel.IsActive = true;
    this.Submitted = false;
    this.ChapterHeadingList=[];
}

ClearSave() {
  this.LearningModel.ChapterID = 0;
  this.LearningModel.ChapterHeading = '';
  this.LearningModel.DisplayOrder='';
  this.LearningModel.IsActive = true;
  this.Submitted = false;
}

Edit(obj) {
  this.LearningModel.ChapterID = obj.ChapterID;
  this.LearningModel.BookTitleID = obj.BookTitleID;
  this.LearningModel.DisplayOrder = obj.DisplayOrder;
  this.LearningModel.ChapterHeading = obj.ChapterHeading;
  this.LearningModel.IsActive = obj.IsActive;

}

ValidityState(){
  return this.LearningModel.BookTitleID==0 || this.LearningModel.ChapterHeading=='';
}


SaveChapterHeading() {  
  this.Submitted = true;
  if (!this.ValidityState()) {
    this.spinnerService.show();
    this.learningservice.SaveChapterHeading(JSON.stringify(this.LearningModel)).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.GetAllChapterHeading();
      }
      if (data.webResponse.Status && this.LearningModel.ChapterID == 0) {
        this.ClearSave();
      }
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
    });
  }

};



MarkActiveChapterHeading(item) {
  this.LearningModel.BookTitleID = item.BookTitleID;
  this.LearningModel.IsActive = item.IsActive == true ? false : true;
  this.spinnerService.show();
  this.learningservice.MarkActiveChapterHeading(JSON.stringify(this.LearningModel)).subscribe((data: any) => {
    if (data.webResponse.Status) {
      this.GetAllChapterHeading();
    }
   
    this.globalHelper.CheckActionStatus(data);
    this.spinnerService.hide();
  });
};
  ngOnInit() {
    this.GetBookTitle();    
  }


  GetBookTitle() {

    this.LookupService.GetLookupsList('LearningBookTitle', '').subscribe((data: any) => {
      this.BookTitleList = data.LookupItems;
    });

  }



}


